import { Box, Icon, Flex } from '@chakra-ui/react';
import { StatRoot, StatLabel, StatValueText } from '@/components/ui/stat';
import { useColorModeValue } from '@/components/ui/color-mode';
import SkeletonCard from './dashboard-skeleton-card';
import { IconType } from 'react-icons';

interface StatsCardProps {
  title: string;
  value: number | string;
  isLoading?: boolean;
  icon?: IconType;
  iconColor?: string;
}

export default function StatsCard({
  title,
  value,
  isLoading = false,
  icon,
  iconColor = 'blue.500',
}: StatsCardProps) {
  const bgColor = useColorModeValue('white', 'gray.800');

  if (isLoading) {
    return <SkeletonCard />;
  }

  return (
    <Box p={5} shadow="md" borderWidth="1px" borderRadius="lg" bg={bgColor}>
      <StatRoot>
        <Flex justify="space-between" align="center" mb={2}>
          <StatLabel fontSize="md" fontWeight="medium" color="gray.600">
            {title}
          </StatLabel>
          {icon && <Icon as={icon} boxSize={6} color={iconColor} />}
        </Flex>
        <StatValueText fontSize="4xl" fontWeight="bold">
          {typeof value === 'number' ? value.toLocaleString() : value}
        </StatValueText>
      </StatRoot>
    </Box>
  );
}
